import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';
import { ZendraLocalizationServices } from '../enums/abpLocalizationServices';
import { localizeWithFallback } from '../utils/localization-utils';

@Pipe({
  name: 'abpLocalization',
  standalone: true,
})
export class ZendraLocalizationPipe implements PipeTransform {
  private readonly localizationService = inject(LocalizationService);

  transform(
    key: string | null | undefined,
    interpolateParams?: unknown,
    fallbackResources?: ZendraLocalizationServices[]
  ): string {
    return localizeWithFallback(
      this.localizationService,
      key || '',
      fallbackResources,
      interpolateParams
    );
  }
}
